import { positionDropdown } from '../../../common/dropdown'
import { Tooltip } from '../../../common/tooltip'

const withMedianTooltip = (Component) => (props) => {
  return (
    <Tooltip
      tooltipContent="portfolio.segment.MEDIAN_SCORE"
      position={positionDropdown.TOP_END_LEFT}
      isI18n={true}
      tooltipContentStyle={{
        backgroundColor: '#1E242E',
        opacity: 1,
        color: '#ECECEC',
      }}
    >
      <Component {...props} />
    </Tooltip>
  )
}

export default withMedianTooltip
